import type { ReactElement, ComponentPropsWithoutRef } from 'react'

export const CommonServicesIcon = (props: ComponentPropsWithoutRef<'svg'>): ReactElement => (
  <svg
    width='16'
    height='14'
    viewBox='0 0 16 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fill='#fff'
      d='M9.3 0c-.5 0-.8.3-.8.8v5c0 .4.3.7.8.7h6c.4 0 .7-.3.7-.8v-5c0-.4-.3-.7-.8-.7h-6ZM6.7 0h-6C.3 0 0 .3 0 .8v5c0 .4.3.7.8.7h6c.4 0 .7-.3.7-.8v-5c0-.4-.3-.7-.8-.7ZM0 8.3v5c0 .4.3.7.8.7h6c.4 0 .7-.3.7-.8v-5c0-.4-.3-.7-.8-.7h-6c-.4 0-.7.3-.7.8ZM9.3 14h6c.4 0 .7-.3.7-.8v-5c0-.4-.3-.7-.8-.7h-6c-.4 0-.7.3-.7.8v5c0 .4.3.7.8.7Z'
    />
  </svg>
)
